<div [fxLayout]="'column'" ngClass.lt-mv="mobile">
  <vpfa-label class="label-text" [text]="label"></vpfa-label>
  <span class="overview-value">{{ value | lT }}</span>
</div>
